// library functions

import { TimelineLite } from "gsap/TimelineLite";
import { TweenLite } from "gsap/TweenLite";

// static data
import { SPRITESHEET_UI } from "Data/Constants";
import * as Topics from "Data/Topics";

// types and interfaces
import type { ILevelState } from "Interfaces/ILevelState";

// gameobjects
import { Button } from "GameObjects/Button";

export class ExteriorLeftRightButtons extends PIXI.Container {
    // children
    public readonly leftButton: Button;
    public readonly rightButton: Button;

    // state

    // allocation
    protected _subscriptions: any[] = [];
    protected hintTimeline?: TimelineLite;

    protected marginLeft: number = 0;
    protected marginRight: number = 0;

    public constructor() {
        super();

        this.leftButton = this.addChild(
            new Button(
                this.onLeftButtonClicked.bind(this),
                "back-btn",
                SPRITESHEET_UI,
                undefined,
                "woosh-quick-2",
            ));
        this.rightButton = this.addChild(
            new Button(
                this.onRightButtonClicked.bind(this),
                "next-btn",
                SPRITESHEET_UI,
                undefined,
                "woosh-quick-2",
            ));

        this._subscriptions.push(
            PubSub.subscribe(Topics.ITEM_FOUND, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.HIDING_SPOT_SEARCHED, this.onMessageReceived.bind(this)),
        );
    }

    public init(pSize: PIXI.Point, pData: ILevelState) {
        return this;
    }

    public animateIn() {
        TweenLite.from(this, 0.5, {pixi: {alpha: 0 }}).delay(0.5);
    }

    public onResize(pSize: PIXI.Point) {
        const inGamesApp = /packageName=org\.pbskids\.gamesapp/.test(window.location.search);
        // https://benfrain.com/how-to-get-the-value-of-phone-notches-environment-variables-env-in-javascript-from-css/
        if (inGamesApp) {
            this.marginLeft = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sal"), 10);
            this.marginRight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sar"), 10);

            if (isNaN(this.marginLeft)) {
                this.marginLeft = 0;
            }
            if (isNaN(this.marginRight)) {
                this.marginRight = 0;
            }
        }

         // TODO: use anchors instead of width/2
        this.leftButton.position.x = -pSize.x / 2 + this.leftButton.width / 2 + 8 + this.marginLeft;
        this.rightButton.position.x = pSize.x / 2 - this.rightButton.width / 2 - 8 - this.marginRight;
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        this._subscriptions.forEach(PubSub.unsubscribe);
        TweenLite.killTweensOf(this);
        this.hintTimeline?.kill();
        super.destroy(pOptions);
    }

    public HintLeft() {
        if (this.hintTimeline === undefined) {
            this.hintTimeline = new TimelineLite();
        }
        this.hintTimeline?.kill();
        this.hintTimeline
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.leftButton, 0.5, {pixi: {scale: 1}})
        ;
    }

    public HintRight() {
        if (this.hintTimeline === undefined) {
            this.hintTimeline = new TimelineLite();
        }
        this.hintTimeline?.kill();
        this.hintTimeline
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.rightButton, 0.5, {pixi: {scale: 1}})
        ;
    }

    public HintBoth() {
        if (this.hintTimeline === undefined) {
            this.hintTimeline = new TimelineLite();
        }
        this.hintTimeline?.kill();
        this.hintTimeline
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1.2}})
            .to([this.leftButton, this.rightButton], 0.5, {pixi: {scale: 1}})
        ;
    }

    public StopHints() {
        this.hintTimeline?.kill();
        this.leftButton.scale.set(1);
        this.rightButton.scale.set(1);
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.ITEM_FOUND:
                break;
            case Topics.HIDING_SPOT_SEARCHED:
                break;
        }
    }

    protected onLeftButtonClicked() {
        PubSub.publishSync(Topics.SCROLL_LEFT, -1);
        this.StopHints();
    }

    protected onRightButtonClicked() {
        PubSub.publishSync(Topics.SCROLL_RIGHT, 1);
        this.StopHints();
    }
}
